import React, { Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Homepage from "./homepage/index";
import Pricing from "./homepage/Pricing";
import About from "./homepage/About";
import Faq from "./homepage/Faq";

const Index = (props) => {
  return (
    <Fragment>
      <Router forceRefresh>
        <Switch>
          <Route exact path="/">
            <Homepage />
          </Route>
          <Route exact path="/pricing">
            <Pricing />
          </Route>
          <Route exact path="/about-us">
            <About />
          </Route>
          <Route exact path="/faq">
            <Faq />
          </Route>
        </Switch>
      </Router>
    </Fragment>
  );
};

export default Index;
